/**
 *
 * PaymentCallback
 *
 */
import Images from 'app/assets/img';
import RenderIf from 'app/components/RenderIf';
import StyledButton from 'app/components/StyledButton';
import { I_Order } from 'app/pages/Account/ListOrder/slice/types';
import {
  selectLayoutFooter,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import {
  NotiContainer,
  StyledDivider,
} from 'app/pages/NewPaymentCallback/components/PaymentFail';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { BOOKING_METHODS, getBookingMethodStr } from '../../Restaurants/config';

interface Props {
  detailOrder?: I_Order;
  isPendingConfirm?: boolean;
  orderId?: number;
  titleText?: string;
  orderNumberText?: string;
  contentText?: string;
  afterOrderNumberContent?: React.ReactNode;
}
export const PaymentSuccess = memo(
  ({
    detailOrder,
    isPendingConfirm,
    orderId,
    titleText,
    orderNumberText,
    contentText,
    afterOrderNumberContent,
  }: Props) => {
    const history = useHistory();
    const translations = useSelector(selectTranslations);
    const footer = useSelector(selectLayoutFooter);
    const isExchangeOrder = Number(detailOrder?.blockItems?.length || 0) > 0;
    const isBavariaFlow_LongTerm = detailOrder?.items?.some((r: any) => getBookingMethodStr(r.restaurant?.methodsEcom) === BOOKING_METHODS.TICKET_RESERVATION) && detailOrder.isLongTerm //kiểm tra vé dài ngày = cách xem có nhà hàng bavaria hay không và có field isLongTerm hay không
    const isBavariaFlow_ShortTerm = detailOrder?.items?.some((r: any) => getBookingMethodStr(r.restaurant?.methodsEcom) === BOOKING_METHODS.TICKET_RESERVATION) && !detailOrder.isLongTerm //kiểm tra vé dài ngày = cách xem có nhà hàng bavaria hay không và có field isLongTerm  = false
    return (
      <div>
        <NotiContainer>
          <div className="icon-container">
            <img src={Images.SuccessIcon} alt="" />
          </div>
          <div className="title-container">
            <h3>
              {titleText ??
                (isPendingConfirm
                  ? translations?.['b2b.txt.sentApprovalRequestSuccessfully']
                  : isExchangeOrder
                    ? translations?.['b2b.upgrade.exchange-ticket-success']
                    : translations?.['b2c.txt.orderSuccessTitle'])}
            </h3>
          </div>
          <div className="order-id">
            {orderNumberText ??
              (translations ? translations['b2c.txt.orderNumber'] : '')}{' '}
            <span>{isPendingConfirm ? orderId : detailOrder?.id}</span>
          </div>
          {afterOrderNumberContent}
          <div className="content-container">
            {contentText ??
              (isPendingConfirm
                ? translations?.['b2b.txt.orderNeedConfirm']
                : translations?.['b2c.txt.orderSuccessContent'])}
          </div>
          {isBavariaFlow_LongTerm && (
            <strong
              style={{
                margin: '0 0 20px',
                padding: '0 12%',
                textAlign: 'center',
                fontSize: 14,
              }}
            >
              {translations?.['b2b.txt.restaurantReservationLongTermSuccessNote']}
            </strong>
          )}
          {isBavariaFlow_ShortTerm && (
            <strong
              style={{
                margin: '0 0 20px',
                padding: '0 12%',
                textAlign: 'center',
                fontSize: 14,
              }}
            >
              {translations?.['b2c.txt.restaurantReservationSuccessNote']}
            </strong>
          )}
          <StyledDivider dashed />
          <div className="contact-container">
            {translations ? translations['b2c.txt.contactHotline'] : ''}
          </div>
          <div className="contact-no-container">
            Hotline <span>{footer?.phoneNumber ?? ''}</span>
          </div>
        </NotiContainer>
        <RenderIf condition={!!isPendingConfirm}>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ margin: '36px 0' }}
          >
            <StyledButton
              bgColor="white"
              border="1px solid #808080"
              textColor="#808080"
              height={'44px'}
              onClick={() => {
                history.push('/account', {
                  targetTab: 'tab-2',
                });
              }}
              style={{
                marginRight: 16,
                width: 'auto',
                minWidth: 160,
              }}
            >
              <i
                className="fa-solid fa-arrow-left"
                style={{ marginRight: 8 }}
              />
              {translations ? translations['b2b.txt.back-to-history'] : ''}
            </StyledButton>
          </div>
        </RenderIf>
      </div>
    );
  },
);
